// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function Tags(props) {
  return JsxRuntime.jsx("div", {
              children: Belt_Array.map(props.tags, (function (tag) {
                      return JsxRuntime.jsx("div", {
                                  children: tag,
                                  className: "category-tag sm"
                                }, tag);
                    })),
              className: "is-flex is-flex-wrap-wrap"
            });
}

var make = Tags;

export {
  s ,
  make ,
}
/* react/jsx-runtime Not a pure module */
